<template>
  <b-modal id="invoicePositionEditModal" size="xl" hide-footer>
    <b-row slot="modal-header">
      <b-col>
        <h6>{{$t('views.exsbinvoices.invoicePositionEditModal.header')}}</h6>
      </b-col>
    </b-row>
    <Update :openInModal="true" :editType="'positions'" :idInvoice="idInvoice"></Update>
  </b-modal>
</template>

<script>
import Update from '../../Update'
export default {
  name: 'InvoicePositionEditModal',
  components: {
    Update
  },
  computed: {
    show () {
      return this.$store.state.modals.exsbinvoices.update.positionsUpdateShow
    },
    close () {
      return this.$store.state.modals.exsbinvoices.update.positionsUpdateClose
    },
    idInvoice () {
      return this.$store.state.modals.exsbinvoices.update.idInvoice
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'idInvoice': function (val) {
      this.openModal()
    },
    'close': function (val) {
      if (val === 1) {
        this.$store.state.modals.exsbinvoices.update.positionsUpdateClose = 0
        this.closeModal()
      }
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.idInvoice > 0) {
        this.$store.state.modals.exsbinvoices.update.positionsUpdateShow = 0
        this.$bvModal.show('invoicePositionEditModal')
      }
    },
    closeModal () {
      this.$bvModal.hide('invoicePositionEditModal')
    },
    resetData () {
      // null
    }
  }
}
</script>
